export const MAJ_USER_SELECTED = 'MAJ_USER_SELECTED'
export const SET_ROUTES = 'SET_ROUTES'
export const REMOVE_USER_SELECTED = 'REMOVE_USER_SELECTED'
export const MAJ_SEARCH_REQUEST = 'MAJ_SEARCH_REQUEST'
export const MAJ_SEARCH_RESULTS = 'MAJ_SEARCH_RESULTS'
export const MAJ_RUBRIQUES_ENTREES = 'MAJ_RUBRIQUES_ENTREES'
export const MAJ_RUBRIQUES_SORTIES = 'MAJ_RUBRIQUES_SORTIES'
export const MAJ_OPERATION_IN_SEARCH_RESULTS = 'MAJ_OPERATION_IN_SEARCH_RESULTS'
export const MAJ_SUBMIT_TO_PROCESS = 'MAJ_SUBMIT_TO_PROCESS'
export const SEND_STICKY = 'SEND_STICKY'
export const ADD_TO_ALL_USERS_SELECTED = 'ADD_TO_ALL_USERS_SELECTED'
export const REMOVE_FROM_ALL_USERS_SELECTED = 'REMOVE_FROM_ALL_USERS_SELECTED'
export const UPDATE_AUTH  = 'UPDATE_AUTH'
export const SYNC_DATA  = 'SYNC_DATA'
export const UPDATE_ROUTES  = 'UPDATE_ROUTES'
export const SET_LICENCES_OF_MEMBER  = 'SET_LICENCES_OF_MEMBER'

export const MAJ_CLUB_SELECTED = 'MAJ_CLUB_SELECTED'
export const REMOVE_CLUB_SELECTED = 'REMOVE_CLUB_SELECTED'
export const ADD_TO_ALL_CLUBS_SELECTED = 'ADD_TO_ALL_CLUBS_SELECTED'
export const REMOVE_FROM_ALL_CLUBS_SELECTED = 'REMOVE_FROM_ALL_CLUBS_SELECTED'

export const MAJ_OPERATION_SELECTED = 'MAJ_OPERATION_SELECTED'
export const ADD_IN_ALL_OPERATIONS_SELECTED = 'ADD_IN_ALL_OPERATIONS_SELECTED'
export const REMOVE_FROM_ALL_OPERATIONS_SELECTED = 'REMOVE_FROM_ALL_OPERATIONS_SELECTED'
export const ADD_VENTILATION_FROM_OPERATION_SELECTED = 'ADD_VENTILATION_FROM_OPERATION_SELECTED'
export const REMOVE_VENTILATION_FROM_OPERATION_SELECTED = 'REMOVE_VENTILATION_FROM_OPERATION_SELECTED'

export const REINIT_ALL_USERS_SELECTED = 'REINIT_ALL_USERS_SELECTED'
export const REINIT_ALL_CLUBS_SELECTED = 'REINIT_ALL_CLUBS_SELECTED'
export const MAJ_LOADING_MODAL_OPERATION = 'MAJ_LOADING_MODAL_OPERATION'
export const MAJ_LOADING_TABLE_OPERATION = 'MAJ_LOADING_TABLE_OPERATION'
export const SET_NOTY_MESSAGE = 'SET_NOTY_MESSAGE'

export const SET_PROFESSIONS = 'SET_PROFESSIONS'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_MAJ_NIXINUT = 'SET_MAJ_NIXINUT'
export const SET_PAYS = 'SET_PAYS'
export const SET_MEMBER = 'SET_MEMBER'
export const SET_TYPES_LICENCES = 'SET_TYPES_LICENCES'
export const SET_VILLES = 'SET_VILLES'
export const SET_CLUB = 'SET_CLUB'
export const SET_PROVINCES = 'SET_PROVINCES'
export const SET_STATUTS_SPORTIFS = 'SET_STATUTS_SPORTIFS'
export const SET_POSTES = 'SET_POSTES'
export const UPDATE_USER = 'UPDATE_USER'
export const CLEAR_ALL_DATA  = 'CLEAR_ALL_DATA'
export const SET_RECAP  = 'SET_RECAP'
export const SET_STATUS_RECAP  = 'SET_STATUS_RECAP'
export const SET_TEXTES_RECAP  = 'SET_TEXTES_RECAP'

export const SET_FORMATION  = 'SET_FORMATION'
export const SET_TYPES_FORMATION  = 'SET_TYPES_FORMATION'
export const SET_LISTE_FORMATION  = 'SET_LISTE_FORMATION'

export const SET_COMPETITION  = 'SET_COMPETITION'
export const SET_NIVEAUX_COMPETITION  = 'SET_NIVEAUX_COMPETITION'
export const SET_LISTE_COMPETITION  = 'SET_LISTE_COMPETITION'

export const SET_CATEG_AGE = 'SET_CATEG_AGE'
export const SET_CATEG_GRADE = 'SET_CATEG_GRADE'
export const SET_CATEG_POIDS = 'SET_CATEG_POIDS'
export const SET_DIPLOMES = 'SET_DIPLOMES'
export const SET_LISTE_CLUB = 'SET_LISTE_CLUB'
export const ADD_MEMBER_TO_SMS = 'ADD_MEMBER_TO_SMS'
export const DELETE_MEMBER_TO_SMS = 'DELETE_MEMBER_TO_SMS'
export const EMPTY_MEMBER_TO_SMS = 'EMPTY_MEMBER_TO_SMS'
export const SET_CRITERES_RANKING = 'SET_CRITERES_RANKING'

export const SET_ORDER = 'SET_ORDER'
export const SET_STATUS_ORDER = 'SET_STATUS_ORDER'
export const SET_TEXTES_ORDER = 'SET_TEXTES_ORDER'
export const SET_MODES_PAYEMENT = 'SET_MODES_PAYEMENT'
export const SET_MODES_LIVRAISON = 'SET_MODES_LIVRAISON'
export const SET_TYPE_PRODUCTS = 'SET_TYPE_PRODUCTS'
export const SET_ORDER_ORIGINAL = 'SET_ORDER_ORIGINAL'







// WEBPACK FOOTER //
// ./src/vuex/mutations-type.js